import { useState, useEffect } from "react";
import GetUserInfoService from "../service/GetUserInfoService";

let cachedUserType = null;
let cachedUsername = null;
let pendingRequest = null;

const useUserType = () => {
  const [userType, setUserType] = useState(cachedUserType);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getUserInfoService = new GetUserInfoService();

  useEffect(() => {
    const username = localStorage.getItem("__extraconomy_username");
    const token = localStorage.getItem("__extraconomy_token");

    if (!token || !username) {
      setUserType(null);
      cachedUserType = null;
      cachedUsername = null;
      return;
    }

    if (cachedUserType && cachedUsername === username) {
      setUserType(cachedUserType);
      return;
    }

    const fetchUserType = async () => {
      if (pendingRequest) {
        try {
          const result = await pendingRequest;
          setUserType(result);
        } catch (err) {
          setError(err);
        }
        return;
      }

      setLoading(true);
      setError(null);

      pendingRequest = getUserInfoService
        .getUserTypeInfo(username)
        .then((res) => {
          if (res.messageCode === 200001) {
            cachedUserType = res.result;
            cachedUsername = username;
            setUserType(res.result);
            return res.result;
          } else {
            throw new Error(`Error fetching user type: ${res.messageCode}`);
          }
        })
        .catch((err) => {
          setError(err);
          throw err;
        })
        .finally(() => {
          setLoading(false);
          pendingRequest = null;
        });

      try {
        await pendingRequest;
      } catch (err) {
        console.error("Error in useUserType:", err);
      }
    };

    fetchUserType();
  }, []);

  return { userType, loading, error };
};

export const clearUserTypeCache = () => {
  cachedUserType = null;
  cachedUsername = null;
  pendingRequest = null;
};

export default useUserType;

